import { api } from '../api';

const API_IDENTITY_CREDENTIALS_PATH = '/identity/credentials';

export const updateCredentials = async ({ email, phoneNumber }) => api.put(
	`${API_IDENTITY_CREDENTIALS_PATH}`,
	{ email, phoneNumber },
);
